module.exports = __webpack_public_path__ + "static/city1-5ff71c89f04b2a54375731fd36f3537b.jpg";